import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import clsx from 'clsx';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';

interface Props {
  color: string;
  nr?: number;
  onClick?: (event: React.SyntheticEvent) => void;
  isActive?: boolean;
  isUnactive?: boolean;
  isCircle?: boolean;
  isFullWidth?: boolean;
  className?: string;
  paletteNr?: number;
}

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      blockStyle: {
        position: 'relative',
        width: '100%',
        maxWidth: '28px',
        height: '28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        // borderRadius: '4px',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            // opacity: 0.7,
            filter: 'brightness(120%)',
            transition: '0.5s ease',
          },
        },
      },
      circleStyle: {
        width: '52px',
        height: '52px',
        borderRadius: '50%',
      },
      activeStyle: {
        outline: `3px solid ${COLORS.red}`,
      },
      activeWhiteStyle: {
        outline: `3px solid ${COLORS.red}`,
      },
      unactiveStyle: {
        opacity: 0.2,
      },
      triangleStyle: {
        position: 'absolute',
        top: '28px',
        right: '50%',
        transform: 'translateX(50%)',
        width: '0',
        height: '0',
        borderLeft: '8px solid transparent',
        borderRight: '8px solid transparent',
        borderTop: '16px solid white',
      },
      triangleCircleStyle: {
        top: '50px',
      },
      fullStyle: {
        maxWidth: '100%',
      },
      insideSquareStyle: {
        position: 'absolute',
        width: 'calc(100% - 3px)',
        height: 'calc(100% - 3px)',
        outline: `1px solid ${COLORS.white}`,
      },
      insideActiveSquareStyle: {
        position: 'absolute',
        width: 'calc(100% - 4px)',
        height: 'calc(100% - 4px)',
        outline: `3px solid ${COLORS.red}`,
      },
      '@media only screen and (max-height: 650px)': {
        blockStyle: {
          width: '22px',
          height: '22px',
        },
      },
      '@media only screen and (max-height: 540px)': {
        blockStyle: {
          width: '18px',
          height: '18px',
        },
      },
      '@media only screen and (max-height: 500px)': {
        blockStyle: {
          width: '14px',
          height: '14px',
        },
      },
    })
);

const isHexLight = (color) => {
  const hex = color.replace('#', '');
  const c_r = parseInt(hex.substring(0, 0 + 2), 16);
  const c_g = parseInt(hex.substring(2, 2 + 2), 16);
  const c_b = parseInt(hex.substring(4, 4 + 2), 16);
  const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;

  return brightness > 155;
};

const SelectColorCode = ({
  color,
  nr,
  onClick,
  isActive,
  isUnactive,
  isCircle,
  isFullWidth,
  className,
  paletteNr,
}: Props): JSX.Element => {
  const classes = useStyles();
  const isWhite = color === '#ffffff';
  const isBlack = color === '#000000';

  return (
    <div
      className={clsx(
        classes.blockStyle,
        // isCircle && classes.circleStyle,
        // isActive && classes.activeStyle,
        // isActive && isWhite && classes.activeWhiteStyle,
        // isUnactive && classes.unactiveStyle,
        // isFullWidth && classes.fullStyle
        className
      )}
      style={{ background: color }}
      onClick={onClick}
      data-nr={nr}
      data-color={color}
      data-palette-nr={paletteNr}
    >
      {/* {isActive && (
        <div
          className={clsx(
            classes.triangleStyle,
            isCircle && classes.triangleCircleStyle
          )}
          style={{ borderTop: `16px solid ${color}` }}
        />
      )} */}
      {!isFullWidth && (
        <div
          className={clsx(
            // isBlack && classes.insideSquareStyle,
            isActive && classes.insideActiveSquareStyle
          )}
        />
      )}
    </div>
  );
};

export default SelectColorCode;
